<template>
  <the-modal @closeModal="closeModal" class="last-activity-modal">
    <div slot="header">
      <h3>{{ $t('booleanSearch.last_activity') }}</h3>
      <div class="header-actions">
        <span class="close fas fa-times" v-on:click="closeModal"></span>
      </div>
    </div>
    <div slot="body">
      <div v-html="activityMessage" />
    </div>
  </the-modal>
</template>

<script>
// Plugins
import moment from 'moment';

import theModal from '../../modal.vue'

//Config
import { activityActions } from '../../../config/bool-const';

export default {
  name: "LastActivityModal",

  computed: {
    activity () {
      return this.$store.state.booleanSearch.active_last_activity;
    },

    activityMessage () {

      const actionText = activityActions[this.activity.action.toUpperCase()];
      const actionDate = moment.utc(this.activity.created_at).format('Do MMMM YYYY HH:mm') + ' (UTC)';
      return `<b><i>
                  ${this.activity.search_title || this.activity.group_name || this.activity.tag_name || this.activity.title}
              </i></b> was ${actionText} by <i>${this.activity.created_by}</i> at ${actionDate}${this.activity.text ? this.activity.text : ''}`;
    }
  },

  methods: {
    closeModal() {
      // 1. clear the activity
      this.$store.commit('booleanSearch/SET_ACTIVITY_ACTIVE', null);
    }
  },

  components: {
    theModal
  }
}
</script>